'use strict';

var React = require('react/addons');
var Index = React.createFactory(require('../index.jsx'));

window.React = React;

React.render(Index(), document.getElementById('app'));


/*****************
 ** WEBPACK FOOTER
 ** ./example/js/index.js
 ** module id = 0
 ** module chunks = 0
 **/